import ModalURlError from 'components/Modal/ModalError/ModalURlError'
import _ from 'lodash'
import { useEffect } from 'react'
import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'
import Basket from '../../components/Basket/Basket'
import { BASKET_TYPES } from '../../components/Basket/constants'
import CinemaTypeImg from '../../components/CinemaTypeImg/CinemaTypeImg'
import OrderStepsHeader from '../../components/OrderStepsHeader/OrderStepsHeader'
import { PAGE_NAME } from '../../components/OrderStepsHeader/constants'
import InfoWindow from '../../components/Windows/InfoWindow/InfoWindow'
import useErrorMessage from '../../components/Windows/InfoWindow/hooks/useErrorMessage'
import { getCinemaType } from '../../global/helpers'
import HallMovie from './components/HallMovie/HallMovie'
import HallSeating from './components/HallSeating/HallSeating'
import hocConnect from './hocConnect'

import ModalWarning from 'components/Modal/ModalWarning/ModalWarning'
import { useLocation } from 'react-router'
import './Hall.scss'

const Hall = ({
    isAuth,
    urlParamsOk,
    loading,
    disable,
    error,
    data,
    loadData,
    selectedSeats,
    emptyBasket,
    handleBasketConfirm,
    setError,
    push,
    modalWarning,
    releaseBasketAndLoadHall,
    message,
}) => {
    const intl = useIntl()
    //Errors
    const errorMessage = useErrorMessage(error?.message)

    const cinemaType = getCinemaType(data?.event_properties.map((property) => property.name))

    //LOADING of HALL DATA
    const { search } = useLocation()
    const params = new URLSearchParams(search)
    const paramsObject = Object.fromEntries(params)
    const eventId = paramsObject.eventid
    const referer = paramsObject.ref
    const site = paramsObject.site

    const releaseBasketAndReloadHall = () => {
        releaseBasketAndLoadHall()
    }

    useEffect(() => {
        if (data?.eventid && data?.title) {
            dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
            dataLayer.push({
                event: 'view_cart',
                ecommerce: {
                    items: [
                        {
                            affiliation: 'Cinestar',
                            coupon: '',
                            item_id: data?.eventid,
                            item_name: data?.title,
                            item_brand: site,
                            item_category: '',
                            item_category2: 'Film',
                        },
                    ],
                },
            })
        }
    }, [data?.eventid, data?.title])

    useEffect(() => {
        loadData({ eventId })
    }, [eventId])

    if (!urlParamsOk) {
        return (
            <div className="min-vh-100">
                <ModalURlError />
            </div>
        )
    }

    const messagesBefore = data?.messages?.filter((item) => item.order < 0)
    const messagesAfter = data?.messages?.filter((item) => item.order > 0)

    return (
        <Container fluid className={'hall-page d-flex flex-column'}>
            <ModalWarning warningType={modalWarning} onContinue={() => releaseBasketAndReloadHall()} />
            <CinemaTypeImg cinemaType={cinemaType} page={PAGE_NAME.hall} imgUrl={data?.imageUrl} imgAlt={data?.title} />
            <OrderStepsHeader
                isAuth={isAuth}
                emptyBasket={emptyBasket}
                loading={loading}
                active={PAGE_NAME.hall}
                text={intl.formatMessage({ id: 'orderSteps.first' })}
                onClickBack={() => push(referer)}
            />
            <div className={'hall-page--content d-flex flex-column mx-auto'}>
                <HallMovie
                    page={PAGE_NAME.hall}
                    cinemaType={cinemaType}
                    loading={loading}
                    movie={data}
                    disable={disable}
                    site={paramsObject.site}
                />

                {messagesBefore?.map((item, index) => (
                    <InfoWindow
                        key={index}
                        color={'white'}
                        description={<div dangerouslySetInnerHTML={{ __html: item.text }} />}
                    />
                ))}

                {data?.shared === false && (
                    <InfoWindow
                        color={'white'}
                        description={intl.formatMessage({ id: 'windows.notification.notShared' })}
                    />
                )}

                {data?.can_booking_by_personal_cash === false && (
                    <InfoWindow
                        color={'white'}
                        description={intl.formatMessage({ id: 'windows.notification.BOOKING_NOT_ALLOWED' })}
                    />
                )}

                {messagesAfter?.map((item, index) => (
                    <InfoWindow
                        key={index}
                        color={'white'}
                        description={<div dangerouslySetInnerHTML={{ __html: item.text }} />}
                    />
                ))}
            </div>
            <HallSeating disable={disable || !data?.shared || loading} eventId={eventId} />
            <div className="astronaut-wrapper d-flex flex-column mx-auto">
                <img
                    src={'images/cinestar/astronaut-thumbs-up.png'}
                    alt={'astronaut-thumbs-up'}
                    className={'astronaut-animate w-50 h-auto mx-auto'}
                />
            </div>
            <Basket
                selectedSeats={selectedSeats}
                variant={BASKET_TYPES.SEATS}
                show={!_.isEmpty(selectedSeats)}
                onConfirm={() => handleBasketConfirm({ selectedSeats })}
            />
        </Container>
    )
}

export default hocConnect(Hall)
